import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { VayuBlocksHeaderTab, usePanelSettings } from '@vayu-blocks';
import Image from './image.js';
import Overlay from './overlay.js';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';

const panelKeys = [
	'slide-image',
	'slide-effect',
	'parallex-effect',
	'slide-caption',
	'overlay-overlay',
	'overlay-frame',
	'overlay-position',
];

const initialPanels = {
	slide: 'slide-image',
	overlay: '',
	advanced: ''
};

const panelOptions = [
	{ label: __('Image', 'vayu-blocks'), value: 'slide', icon: 'image' },
	{ label: __('Overlay', 'vayu-blocks'), value: 'overlay', icon: 'colorwand' },
	{ label: __('Advanced', 'vayu-blocks'), value: 'advanced', icon: 'colorpalette' },
];

const PanelSettings = ({ attributes, setAttributes, isSelected, clientId }) => {

	const {tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide'});

	const tabComponents = {
		slide: <Image attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		overlay: <Overlay attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} video={true} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};

	return (
		isSelected && (
			<InspectorControls>
				<div className="th-block-ins th-button-panel">
					<VayuBlocksHeaderTab
						value={tab}
						options={panelOptions}
						onChange={setTab}
					/>

					{tabComponents[tab]}

				</div>
			</InspectorControls>
		)
	);
};

export default PanelSettings;
